export default {
  gallery: {
    image: 'Image',
    close: 'Close',
    next: 'Next',
    previous: 'Previous'
  }
}
